<script setup lang="ts">
import { Button } from '@/components/ui/button';
import useSheet from '@/composables/useSheet.ts';

const props = defineProps<{
    slug: string;
}>();

const sheet = useSheet();

async function open() {
    const response = await fetch('/contact/' + props.slug);
    const html = await response.text();

    await sheet.start({
        title: 'Ansprechpartner',
        class: 'max-w-1/2 2xl:w-140',
        content: html,
    });
}
</script>

<template>
    <Button @click="open">
        <slot />
    </Button>
</template>
